import ReactDOM from 'react-dom/client'
import { pipe } from 'remeda'
import { CategoriesGrid } from '@components/CategoriesGrid/CategoriesGrid'
import { withI18next, withSkeletonTheme, withTheme } from '@hocs'
import type { MacroCategoriesCardsProps } from '@velasca/types'
import { MaxWidthContainer } from '@velasca/ui/max-width-container'

interface Page404AppParams {
  page404El: HTMLElement | null
  categoriesBlocksData: MacroCategoriesCardsProps
}

export const renderPage404App = ({
  page404El,
  categoriesBlocksData,
}: Page404AppParams) => {
  if (page404El) {
    const Page404App = () => (
      <MaxWidthContainer>
        <CategoriesGrid
          title={null}
          mobileLayout="singleColumn"
          cards={categoriesBlocksData.imageCards ?? []}
        />
      </MaxWidthContainer>
    )

    const Page404AppWrapper = pipe(
      Page404App,
      withSkeletonTheme,
      withI18next,
      withTheme,
    )

    ReactDOM.createRoot(page404El).render(<Page404AppWrapper />)
  }
}
